import { Link } from "react-router-dom";
import type { ReactNode } from "react";

/**
 * Smart ad link: uses react-router Link for internal routes,
 * and <a target="_blank"> for external URLs.
 */
export function isExternalUrl(url: string): boolean {
  return /^https?:\/\//.test(url);
}

interface AdLinkProps {
  href: string;
  className?: string;
  children: ReactNode;
  onClick?: () => void;
}

export default function AdLink({ href, className, children, onClick }: AdLinkProps) {
  if (!href || href === "#") {
    return <div className={className}>{children}</div>;
  }

  if (isExternalUrl(href)) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={className} onClick={onClick}>
        {children}
      </a>
    );
  }

  return (
    <Link to={href} className={className} onClick={onClick}>
      {children}
    </Link>
  );
}
